module.exports = __webpack_public_path__ + "img/img-joker.5f7b0e86.png";